module.exports = __webpack_public_path__ + "img/longblack.3390317f.png";